import { CSSProperties } from 'react';
import Icons from './assets/icons.svg';

export interface IconProps {
  /**
   * Size of the icon, can also be passed as fontSize in the style object.
   *
   * @default 24
   */
  size?: number | undefined;
  name: string;
  color?: string | undefined;
  iconStyle?: CSSProperties | undefined;
}

const Icon = ({
  name,
  color = 'var(--base-black)',
  size = 24,
  iconStyle,
}: IconProps) => {
  return (
    <svg
      style={iconStyle}
      width={size}
      height={size}
      stroke={color}
      fill="none"
    >
      <use href={`${Icons}#${name}`} />
    </svg>
  );
};

export default Icon;
